import { useWatch } from 'react-hook-form';

import { Typography } from '@mui/material';

import { IFieldTableRowTitleProps } from './types';

import styles from './FieldTableRowTitle.module.scss';

export const FieldTableRowTitle: React.FC<IFieldTableRowTitleProps> = ({
  watchRowTitleName,
  defaultTitle = 'Untitled',
}) => {
  const rowName: string = useWatch({ name: watchRowTitleName });

  return (
    <Typography variant="subtitle2" className={styles.title}>
      {rowName || defaultTitle}
    </Typography>
  );
};
